import { Link } from 'react-router-dom';

export function RegisterPage() {
  return (
    <div>
      <h1 className="mb-1 text-2xl font-bold text-foreground">Registration is closed</h1>
      <p className="mb-8 text-sm text-muted-foreground">
        New accounts are disabled while email and phone verification are being configured.
      </p>
      <p className="text-center text-sm text-muted-foreground">
        Already set up your account?{' '}
        <Link to="/auth/login" className="font-medium text-primary hover:underline">Sign in</Link>
      </p>
    </div>
  );
}
